export enum ModalState{
  Closed= "ModalState.Closed"
}
